import 'animate.css';
import 'bootstrap/dist/css/bootstrap.css';

import config from './config';
import { loadScript } from './helpers/script';

loadScript(`${window.location.protocol}//www.googletagmanager.com/gtag/js?id=${config.googleTagManagerId}`, null, null, {
  async: true,
  shouldPrepend: true,
  isHead: true,
});

window.dataLayer = window.dataLayer || [];

window.gtag = function() {
  window.dataLayer.push(arguments);
}

loadScript(`${window.location.protocol}//script.crazyegg.com/pages/scripts/0077/1945.js`, null, null, {
  async: true,
  shouldPrepend: true,
  isHead: true,
});
window.gtag('js', new Date());
window.gtag('config', config.googleTagManagerId, { 'optimize_id': config.googleOptimizeId });



// WEBPACK FOOTER //
// ./src/vendor.js